<div class="d-flex justify-content-center apt-container">
    <div class="w-100 apt-details text-capitalize"> 
        <mat-card class="apt-details-card" [ngClass]="{'bg-blue': defaultTemplate}" (click)="onRowClicked()" onKeyDown="doNothing();" tabindex="0">
            <mat-card-header>
                <mat-card-title-group class="align-items-center">
                    <div class="card-header-flex">
                        <mat-icon *ngIf="defaultTemplate" class="me-2">check</mat-icon>
                        <mat-card-title class="d-flex w-50 align-items-center u-name text-capitalize">
                            <span class="card-title ellipsis-text" [title]="template?.name">{{template?.name}}</span>
                        </mat-card-title>
                        <span class="spacer"></span>
                        <button type="button" class="no-button card-action-button" aria-label="Toggle favorite"
                            (click)="onAction($event, 'fav')">
                        <mat-icon  [ngClass]="{'text-yellow-500':template?.starred}"
                            class="mr-2 star-icon">
                            {{ template?.starred ? 'star' : 'star_border' }}
                        </mat-icon>
                        </button>
                        <button type="button" class="no-button card-action-button" aria-label="Template actions"
                            (click)="$event.stopPropagation()">
                        <mat-icon class="more-actions-icon" [matMenuTriggerFor]="menu">more_vert</mat-icon>
                        </button>

                        <mat-menu #menu="matMenu">
                            <button type="button" mat-menu-item (click)="onAction($event,'edit')"
                                [class.cursor-not-allowed]="template?.createdBy !== CREATED_BY.ME"
                                [disabled]="template?.createdBy !== CREATED_BY.ME">
                                <mat-icon>edit</mat-icon> Edit
                            </button>
                            <button type="button" mat-menu-item (click)="onAction($event,'delete')"
                                [class.cursor-not-allowed]="template?.createdBy !== CREATED_BY.ME"
                                [disabled]="template?.createdBy !== CREATED_BY.ME">
                                <mat-icon>delete</mat-icon> Delete
                            </button>
                            <button type="button" mat-menu-item (click)="onAction($event,'set-default')">
                                <mat-icon>check</mat-icon> Set Default
                            </button>
                            <button type="button" mat-menu-item (click)="onAction($event,'fav')">
                                <mat-icon>star_border</mat-icon>
                                {{template?.starred ? 'Remove from favorite' : 'Add to favorite'}}
                            </button>
                        </mat-menu>
                    </div>
                </mat-card-title-group>
            </mat-card-header>
            <mat-card-content>
                <div class="row">
                    <div class="col-4">
                        <div class="label">Category</div>
                        <div class="value">{{template?.category}}</div>
                    </div>
                    <div class="col-4">
                        <div class="label">Visibility</div>
                        <div class="value">{{template?.privacy}}</div>
                    </div>
                    <div class="col-4">
                        <div class="label">Created By</div>
                        <div class="value"> {{ template?.createdBy }}</div>

                    </div>
                </div>
                <div class="row">
                    <div class="col-12 desc">
                        <div class="label">Description</div>
                        <div class="ellipsis-desc value" [title]="template?.description"> {{ template?.description}}</div>
                    </div>
                </div>
            </mat-card-content>
        </mat-card>
    </div>
</div>
